import { parseDate, parseNumber, parseString } from 'utils/parsingHelpers'

export interface SafetyJSON {
  training_location?: string
  website_url?: string
  site_specific_date?: Date
  site_specific_time?: string
  site_specific_hours?: number
  other_training_info?: string
  slack_link?: string
  gdrive_link?: string
  hole_watch?: {
    contact_name?: string
    contact_phone?: string
    customer_supplied?: string
  }
}

export const parseSafetyJSON = (value: unknown): SafetyJSON | undefined => {
  if (!value || typeof value !== 'object') return undefined

  const data = value as Record<string, unknown>
  return {
    training_location: parseString(data.training_location),
    website_url: parseString(data.website_url),
    site_specific_date: parseDate(data.site_specific_date),
    site_specific_time: parseString(data.site_specific_time),
    site_specific_hours: parseNumber(data.site_specific_hours),
    other_training_info: parseString(data.other_training_info),
    slack_link: parseString(data.slack_link),
    gdrive_link: parseString(data.gdrive_link),
    hole_watch: data.hole_watch
      ? {
          contact_name: parseString(
            (data.hole_watch as Record<string, unknown>).contact_name
          ),
          contact_phone: parseString(
            (data.hole_watch as Record<string, unknown>).contact_phone
          ),
          customer_supplied: parseString(
            (data.hole_watch as Record<string, unknown>).customer_supplied
          ),
        }
      : undefined,
  }
}
